import React from "react";
import {Product} from "../../Models/Product/Product";

export interface IProps {
    product : Product
}

export function MinimumAmountReached(props : IProps) : React.ReactElement {

    return (
        <div id="lb-product-minimum-amount-reached" className="light-box warning" data-light-box={true} data-lb-state="hidden">
            <div className="lb-inner">
                <div className="lb-header">
                    <h6>Upozornění</h6>
                    <button className="reset close" data-lb-action="hide"><i className="fa fa-times" /></button>
                </div>
                <div className="lb-body">
                    <div className="container-fluid">
                        <p>Produkt lze objednat v minimálním množství {props.product.minimumSaleAmount} <span
                            dangerouslySetInnerHTML={{__html: props.product.measurementUnit.html}}/>.</p>
                    </div>
                </div>
                <div className="lb-footer">
                    <button type="button" className="button background-color-orange next" data-lb-action="hide"><i className="fa fa-check" />Rozumím</button>
                </div>
            </div>
        </div>
    );
}